import React from 'react';
import { ColourLabel } from 'omni-common-ui';
import { isActive } from 'containers/Group/status';
import PropTypes from 'prop-types';

const GroupStatus = (props) => {
  const { status, initial } = props;
  const colour = isActive(status) ? '#74d17f' : '#de4c4c';
  return <ColourLabel text={status} initial={initial} colour={colour} />;
};

GroupStatus.propTypes = {
  status: PropTypes.string,
  initial: PropTypes.string,
};

export default GroupStatus;



// WEBPACK FOOTER //
// ./components/GroupStatus/index.jsx